import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";


import { FaUserCircle } from "react-icons/fa";
import { IoMdReturnRight } from "react-icons/io";
import logo2 from '../../assets/logo2.png';

import { pageRoutes } from '../../routes/pageRoutes';

import { ProfileForm } from '../../component/Form/ApplicantForm/ProfileForm';
import { WorkExperience } from '../../component/Form/ApplicantForm/WorkExperience';
import { EducationalBackground } from '../../component/Form/ApplicantForm/EducationalBackground';
import { SupportContact } from '../../component/Form/ApplicantForm/SupportContact';
import { SkillTree } from '../../component/Form/ApplicantForm/SkillTree';
import { Portfolio } from '../../component/Form/ApplicantForm/Portfolio';

const UserForm = () => {

    const navigate = useNavigate();

    const [stepper, setStepper] = useState(parseInt(1));

    const handleStepper = (data) => {
        setStepper(parseInt(data))
    }

    const handleChangeStatusColor = (data) => {

        if (data === stepper) return "bg-green-800"
        else if (data < stepper) return "bg-green-500"
        else return "bg-gray-300"

    }

    return (
        // <BackgroundAuth isWholePage={true}>
        <React.Fragment>

            <div className='w-full flex h-screen overscroll-none'>
                <div className='h-full w-[90px] bg-green-50 p-4 sticky top-0 h-screen overflow-y-auto'>

                    <div className='flex flex-col items-center gap-3 mt-7'>

                        <div onClick={() => handleStepper(1)} className={`${handleChangeStatusColor(1)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            1
                        </div>


                        <div onClick={() => handleStepper(2)} className={`${handleChangeStatusColor(2)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            2
                        </div>

                        <span className='border-[1.5px] border-gray-300 py-5'></span>

                        <div onClick={() => handleStepper(3)} className={`${handleChangeStatusColor(3)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            3
                        </div>


                        {/* <div onClick={() => handleStepper(2)} className={`${handleChangeStatusColor(2)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            2
                        </div> */}


                        {/* <div onClick={() => handleStepper(5)} className={`${handleChangeStatusColor(5)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            5
                        </div>

                        <span className='border-[1.5px] border-gray-300 py-5'></span>

                        <div onClick={() => handleStepper(6)} className={`${handleChangeStatusColor(6)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            6
                        </div> */}

                        <span className='border-[1.5px] border-gray-300 py-5'></span>

                        <div onClick={() => handleStepper(2)} className={`${handleChangeStatusColor(2)} rounded-full flex flex-col items-center justify-center text-white px-4 py-2`}>
                            2
                        </div>

                    </div>

                </div>

                {stepper === 1 && <ProfileForm handleStepper={handleStepper} />}
                {stepper === 2 && <WorkExperience handleStepper={handleStepper} />}
                {stepper === 3 && <EducationalBackground handleStepper={handleStepper} />}
                {/* {stepper === 2 && <SupportContact handleStepper={handleStepper} />} */}
                {/* {stepper === 5 && <SkillTree handleStepper={handleStepper} />}
                {stepper === 6 && <Portfolio handleStepper={handleStepper} />} */}

                {stepper === 2 &&
                    <React.Fragment>
                        <div className='flex-1 p-4 overflow-y-auto'>



                            <div className='w-full p-4 bg-green-300 rounded'>
                                Your application has been succesfully submitted
                            </div>

                            <div className='flex justify-end w-full mt-2 flex-end'>

                                <div onClick={() => navigate(pageRoutes.APPLICANT)} className='flex flex-row items-center justify-center gap-2 px-3 py-2 font-medium text-white bg-green-600 rounded cursor-pointer font-lexend hover:bg-green-800'>
                                    <span>Return to Dashboard</span>
                                    <IoMdReturnRight />
                                </div>

                            </div>

                        </div>
                    </React.Fragment>
                }

            </div>

        </React.Fragment>
    )
}

export default UserForm;
